"use strict";
var getBuiltIn = require("../internals/get-built-in");
var call = require("../internals/function-call");
var uncurryThis = require("../internals/function-uncurry-this");
var bind = require("../internals/function-bind-context");
var anObject = require("../internals/an-object");
var aCallable = require("../internals/a-callable");
var isNullOrUndefined = require("../internals/is-null-or-undefined");
var getMethod = require("../internals/get-method");
var wellKnownSymbol = require("../internals/well-known-symbol");
var ASYNC_DISPOSE = wellKnownSymbol("asyncDispose");
var DISPOSE = wellKnownSymbol("dispose");
var push = uncurryThis([].push);
var getDisposeMethod = function(V, hint) {
  if (hint === "async-dispose") {
    var method = getMethod(V, ASYNC_DISPOSE);
    if (method !== void 0) return method;
    method = getMethod(V, DISPOSE);
    if (method === void 0) return method;
    return function() {
      var O = this;
      var Promise = getBuiltIn("Promise");
      return new Promise(function(resolve) {
        call(method, O);
        resolve(void 0);
      });
    };
  }
  return getMethod(V, DISPOSE);
};
var createDisposableResource = function(V, hint, method) {
  if (arguments.length < 3 && !isNullOrUndefined(V)) {
    method = aCallable(getDisposeMethod(anObject(V), hint));
  }
  return method === void 0 ? function() {
    return void 0;
  } : bind(method, V);
};
module.exports = function(disposable, V, hint, method) {
  var resource;
  if (arguments.length < 4) {
    if (isNullOrUndefined(V) && hint === "sync-dispose") return;
    resource = createDisposableResource(V, hint);
  } else {
    resource = createDisposableResource(void 0, hint, method);
  }
  push(disposable.stack, resource);
};
